import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const hero = document.getElementById('hero-sentinel');
      const offer = document.getElementById('get-access');
      const heroBottom = hero ? hero.getBoundingClientRect().bottom : 600;
      const offerTop = offer ? offer.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      const pastHero = heroBottom < 0;
      const atPrice = offerTop < window.innerHeight * 0.9;
      setVisible(pastHero && !atPrice);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-106" data-mp="38bqt7vbrsf9j">
      {visible && <motion.a href="#get-access" initial={{
      y: '100%'
    }} animate={{
      y: 0,
      boxShadow: ['0 -4px 14px -4px rgba(255,107,53,0.45)', '0 -6px 26px -4px rgba(255,107,53,0.85)', '0 -4px 14px -4px rgba(255,107,53,0.45)']
    }} exit={{
      y: '100%'
    }} transition={{
      y: {
        duration: 0.3,
        ease: 'easeOut'
      },
      boxShadow: {
        duration: 2.2,
        ease: 'easeInOut',
        repeat: Infinity
      }
    }} className="fixed inset-x-0 bottom-0 z-40 flex h-[54px] items-center justify-center bg-accent text-[15px] font-extrabold tracking-tight text-card md:hidden" data-id="element-107" data-mp="38cs7e8o31hvh">
          CHCĘ CAŁĄ PRACOWNIĘ ZA 73 ZŁ
        </motion.a>}
    </AnimatePresence>;
}